<template>
  <div class="customer-member">
    <breadcrumb :breadcrumbList="breadcrumbList"></breadcrumb>
    <div class="customer-member-content">
      <top-content></top-content>
      <member-list></member-list>
    </div>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'
import Breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import { breadcrumbList } from './config'
import TopContent from './cpns/top-content/top-content.vue'
import MemberList from './cpns/member-list/member-list.vue'
export default defineComponent({
  props: {

  },
  components: {
    Breadcrumb,
    TopContent,
    MemberList
  },
  setup() {


    return {
      breadcrumbList
    }

  }
})
</script>

<style scoped lang="less">
.customer-member {
  .customer-member-content {
    padding: 20px;
    margin: 20px;
    background-color: #fff;
  }
}
</style>




